import { Injectable } from '@angular/core';
import { BaseService } from 'app/_services/base.service';
import { SettingsService } from 'app/_services/settings.service';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ImageDisplayService extends BaseService  {
    image: Subject<string> = new Subject<string>();

    constructor(private config: SettingsService) {
        super();
    }

    public setImage(imageSrc: string) {
        this.image.next(imageSrc)
    }

    public getImage() {
        return this.image.asObservable();
    }
}
